<button mat-icon-button class="pagination-button" [disabled]="currentPage <= 1" (click)="loadPage(1)">
    <mat-icon>first_page</mat-icon>
</button>
<button mat-icon-button class="pagination-button" [disabled]="currentPage <= 1" (click)="loadPage(currentPage - 1)">
    <mat-icon>chevron_left</mat-icon>
</button>
<mat-form-field class="pagination-form-field" appearance="outline">
    <mat-select [(value)]="currentPage" (selectionChange)="loadPage($event.value)" placeholder="Jump to page">
        @for (page of pages; track page) {
            <mat-option [value]="page">Page {{page}} of {{pageCount}}</mat-option>
        }
    </mat-select>
</mat-form-field>
<button mat-icon-button class="pagination-button" [disabled]="currentPage >= pageCount" (click)="loadPage(currentPage + 1)">
    <mat-icon>chevron_right</mat-icon>
</button>
<button mat-icon-button class="pagination-button" [disabled]="currentPage >= pageCount" (click)="loadPage(pageCount)">
    <mat-icon>last_page</mat-icon>
</button>
